var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mx-3"},[_c('router-link',{attrs:{"to":{ name: 'StorageDashboard' }}},[_vm._v(_vm._s(_setup.localize("Back to Dashboard")))]),_vm._v(" "),_c(_setup.Heading,{staticClass:"my-3",attrs:{"h1":"","bold":""}},[_vm._v(_vm._s(_setup.localize(_vm.title)))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }